import React from 'react';
import { useTranslation } from 'react-i18next';
import PageSizeSelector from '../../components/PageSizeSelector';

const Pagination = ({ PAGE_SIZE, setPage, page, S, filtered, total, setPageSize }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '14px 32px',
        borderTop: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.8)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      <span style={{ fontSize: 13, color: S.textMuted }}>
        {t('screens.claimsScreen.showingOf', { shown: filtered.length, total })}
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {typeof PAGE_SIZE === 'number' && setPageSize && (
          <PageSizeSelector pageSize={PAGE_SIZE} setPageSize={setPageSize} />
        )}
        <div style={{ display: 'flex', gap: 4 }}>
        {Array.from({ length: Math.max(1, Math.ceil(total / PAGE_SIZE)) }, (_, i) => i + 1).map(p => (
          <button
            key={p}
            onClick={() => setPage(p)}
            style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              border: p === page ? `1px solid ${S.burgundy}` : `1px solid ${S.borderLight}`,
              background: p === page ? 'rgba(128,0,32,0.07)' : '#fff',
              color: p === page ? S.burgundy : S.textSecondary,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {p}
          </button>
        ))}
        </div>
      </div>
    </div>
  );
};

export default Pagination;
